import { Injectable } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { Geolocation, Position, PositionOptions, WatchPositionCallback } from "@capacitor/geolocation";
import { Observable } from "rxjs";
import { IGeoLocationDbModel } from "../models/interfaces/coords";
import { IGenericResponse } from "../models/interfaces/i-generic-response";
import { LoadingService } from "./loading.service";
import { PermissionService } from "./permission.service";

@Injectable({
    providedIn: "root"
})
export class LocationService {
    public static isLocationAvailable: boolean = false;
    private static _currentCoords: Position = {
        timestamp: Date.now(),
        coords: {
            accuracy: -1,
            altitude: -1,
            altitudeAccuracy: -1,
            heading: -1,
            speed: -1,
            longitude: 27.447,
            latitude: 38.131
        }
    };
    public static get currentCoords() {
        return LocationService._currentCoords;
    }
    private static set currentCoords(value) {
        LocationService._currentCoords = value;
    }

    /**
     *
     */
    constructor(private loadingService: LoadingService) { }
    public static async GetMyCurrentLocationStatic(): Promise<IGenericResponse<GeolocationCoordinates>> {
        return new Promise((resolve, reject) => {
            try {

                PermissionService.CheckAndRequestLocation({
                    granted: async () => {
                        let options: PositionOptions = {
                            enableHighAccuracy: true,
                            maximumAge: 1000 * 60 * 3 // 5 dakikalık bir cacheleme ekledim.
                        }
                        try {
                            let location = await Geolocation.getCurrentPosition(options);
                            let resp = { IsSuccess: true, Data: location.coords, Message: "success", StatusCode: 1 } as IGenericResponse<GeolocationCoordinates> //location.coords
                            LocationService.isLocationAvailable = true;
                            resolve(resp)
                        } catch (error) {
                            console.error("manual g => ", error)
                            let errResp = { IsSuccess: false, Data: error, Message: "error_on_get_position", StatusCode: 0 } as IGenericResponse<GeolocationCoordinates> //location.coords
                            reject(errResp)
                        }
                    },
                    rejected: async (error) => {
                        console.error("manual => ", error)
                        let errResp = { IsSuccess: false, Data: null, Message: "permissionDenied", StatusCode: 0 } as IGenericResponse<GeolocationCoordinates> //location.coords
                        reject(errResp)
                    }
                })


            } catch (error) {
                console.error(error)
                let errResp = { IsSuccess: false, Data: null, Message: "permissionDenied", StatusCode: 0 } as IGenericResponse<GeolocationCoordinates> //location.coords
                reject(errResp)
            }

        })
    }
    public static async GetMyCurrentLocation(): Promise<IGenericResponse<GeolocationCoordinates>> {
        return new Promise((resolve, reject) => {
            let scope = this;
            LocationService.isLocationAvailable = false;
            // scope.isLocationAvailable = false
            try {
                PermissionService.CheckAndRequestLocation({
                    granted: async () => {
                        let options: PositionOptions = {
                            enableHighAccuracy: true,
                            maximumAge: 1000 * 60 * 3 // 5 dakikalık bir cacheleme ekledim.
                        }
                        try {
                            let location = await Geolocation.getCurrentPosition(options);
                            let resp = { IsSuccess: true, Data: location.coords, Message: "success", StatusCode: 1 } as IGenericResponse<GeolocationCoordinates> //location.coords
                            // StorageService.Set(StorageKeys.MY_LATEST_LOCATION, location.coords)
                            // scope.isLocationAvailable = true;
                            LocationService.isLocationAvailable = true;
                           
                            resolve(resp)
                        } catch (error) {

                            let errResp = { IsSuccess: false, Data: error, Message: "error_on_get_position", StatusCode: 0 } as IGenericResponse<GeolocationCoordinates> //location.coords
                            reject(errResp)
                        }
                    },
                    rejected: async (error) => {
                        let errResp = { IsSuccess: false, Data: null, Message: "permissionDenied", StatusCode: 0 } as IGenericResponse<GeolocationCoordinates> //location.coords
                        reject(errResp)
                    }
                })


            } catch (error) {
                let errResp = { IsSuccess: false, Data: null, Message: "permissionDenied", StatusCode: 0 } as IGenericResponse<GeolocationCoordinates> //location.coords
                reject(errResp)
            }

        })
    }
    public static async GetLocationFromIp(): Promise<IGeoLocationDbModel> {
        try {
            let fetchResponse = await fetch("https://geolocation-db.com/json/")
            let data = await fetchResponse.json() as IGeoLocationDbModel
            // StorageService.Set(StorageKeys.MY_LATEST_LOCATION, { accuracy: 0, altitude: 0, altitudeAccuracy: 0, heading: 0, latitude: data.latitude, longitude: data.longitude, speed: 0 } as GeolocationCoordinates)
            return data
        } catch (error) {
            return null
        }
    }
    public static WatchMyLocation(): Observable<Position> {
        /**
         * bu değişken oturduğum yerden konum değişti demek içindi
         */
        // let prevCount = 0;
        return new Observable<Position>(observer => {
            let options: PositionOptions = {
                enableHighAccuracy: true,
                maximumAge: 1000 * 30 * 1 // 1 dakikalık bir cacheleme ekledim.
            }

            let callback: WatchPositionCallback = (ev) => {
                if (ev) {
                    this._currentCoords = ev
                    observer.next(ev)
                } else {
                    observer.next(null)
                }
            }
            Geolocation.watchPosition(options, callback).then(res => {

            })
        })
    }
   

}